import { getMenuForTenant } from "./tenantMenuConfigs";
import { getTenantId } from "../../../api/ApiUtils";

export const getMenuItems = (t) => {
  const tenantId = getTenantId();
  return getMenuForTenant(tenantId, t);
};
